import type { RenderProps } from 'hb-builder/components/common/type/RenderProps';
import { Wrapper as WrapperRender } from 'hb-builder/components/common/Wrapper/WrapperRender';
import WrapperUI from 'hb-builder/components/UIComponents/page/common/Wrapper/WrapperUI';
import type { RenderComponent } from 'hb-builder/types';
import type { DocumentItem } from 'hb-react/backoffice/types/builder/builderDocument';
import type { WrapperItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/wrapperItemAttributes';

const componentType = 'Wrapper';

const Wrapper: RenderComponent = () => <div />; // never used

const Render = ({
  children,
  item,
}: RenderProps<DocumentItem<WrapperItemAttributes>>) => {
  const { attributes, children: childrenItem } = item || {};
  const hasMultipleChildren = (childrenItem?.length || 0) > 1;

  return (
    /* @ts-expect-error untyped */
    <WrapperRender attributes={attributes} componentType={componentType}>
      <WrapperUI
        boxProps={{ maxWidth: '100%' }}
        attributes={attributes}
        hasMultipleChildren={hasMultipleChildren}
      >
        {children}
      </WrapperUI>
    </WrapperRender>
  );
};

Wrapper.componentName = 'Wrapper';
Wrapper.Render = Render;

Wrapper.item = ({ attributes = {}, category, children, name, type }) => ({
  attributes,
  category,
  children,
  name,
  type: type || Wrapper.componentName,
});

export default Wrapper;
